/**
 * Default fair-usage credit limit assigned to a seat-based user when their
 * per-user limit isn't otherwise configured.
 *
 * Shared between the `UserSeatCreditLimit` column default, the Propel webhook
 * that seeds new users, and the admin new-billing-period dialog.
 */
export const DEFAULT_SEAT_CREDIT_LIMIT = 10000;

export const LEGACY_PAGES_PER_CREDIT = 1;
export const DEFAULT_COST_BASED_PAGES_PER_CREDIT = 15;
